import getTempUserShortId from '../utils/getTempUserId'
import React, { useEffect, useState } from 'react'
import { NameAndAddress } from '../Types/models/user'
import {
	StartPaymentBackend,
	StartPaymentFrontend,
	StartPaymentRes,
} from '../Types/dto/startPayment'
import { useAuth } from '../hooks/useAuth'
import env from '../configs/env'
import { fetchWithBaseUrl } from '../../utils/api'
import { UserProductDTOFields } from '../Types/dto/user/product'
import useLocalStorageTX2 from '../hooks/useLocalStorageTX2'
import ReactGA from 'react-ga'

export default function Checkout({
	completion,
	platform,
	totalPriceFormatted,
	isCalendar,
}: {
	completion?: Function
	platform: string
	totalPriceFormatted?: string
	isCalendar?: Boolean
}) {
	const user = useAuth().userDTO
	const [email2, setEmail2] = useState<string | undefined>(undefined)
	const [startPaymentFrontend, setStartPaymentFrontend] =
		useLocalStorageTX2<StartPaymentFrontend>('startPaymentFrontend.v4', {
			adSubPagesData: {},
			formFieldData: {},
			partnerData: { country: 'Magyarország' },
		})

	const [userProductDTO, setUserProductDTOFields] = useLocalStorageTX2<{
		[productSlug: string]: UserProductDTOFields
	}>('buyTicketData', {})
	const auth = useAuth()
	const [teamSlugUser, setTeamSlugUser] = useLocalStorageTX2<
		string | undefined
	>('teamSlugUser', undefined)
	const [productSlugUser, setProductSlugUser] = useLocalStorageTX2<
		string | undefined
	>('productSlugUser', undefined)
	const [penultimateElement, setPenultimateElement] = useLocalStorageTX2<
		string | undefined
	>('productSlugUser', undefined)
	/*const [adSubPageId, setAdSubPageId] =
		useLocalStorageTX2<string>('adSubPageId', '')*/

	useEffect(() => {
		const pathname = window.location.pathname
		const pathSegments = pathname.split('/').filter((segment) => segment)
		const _penultimateElement =
			pathSegments.length >= 2 ? pathSegments[pathSegments.length - 2] : ''
		setPenultimateElement(_penultimateElement)
	}, [])

	useEffect(() => {
		const _partnerData = user?.partnerData
		if (_partnerData && startPaymentFrontend) {
			setStartPaymentFrontend({
				...startPaymentFrontend,
				partnerData: _partnerData,
			})
		} else if (startPaymentFrontend) {
			setStartPaymentFrontend({
				...startPaymentFrontend,
				partnerData: { country: 'Magyarország' },
			})
		}
	}, [user])

	const startPayment = async (isRedirectToBarion: boolean) => {
		if (!teamSlugUser || !productSlugUser) {
			return
		}
		const partnerData = startPaymentFrontend?.partnerData
		if (
			!partnerData?.name ||
			!partnerData?.country ||
			!partnerData?.postalCode ||
			!partnerData?.city ||
			!partnerData?.address
		) {
			alert(`Kérlek, töltsd ki az összes mezőt!`)
			return
		}
		if (!startPaymentFrontend?.email && (!user || !user?.email)) {
			alert('Kérlek, add meg az e-mail címed!')
			return
		} else if (
			(!user &&
				startPaymentFrontend?.email &&
				startPaymentFrontend?.email != email2) ||
			(user &&
				!user?.email &&
				startPaymentFrontend?.email &&
				startPaymentFrontend?.email != email2)
		) {
			alert('Megadott e-mail címek nem egyeznek!')
			return
		}
		if (
			startPaymentFrontend?.email &&
			startPaymentFrontend?.email.includes('freemail.hu')
		) {
			alert(
				'Amennyiben freemail-es e-maillel próbálsz megadni, abban az esetben kérjük használj másikat. A rendszer a freemail.hu-t nem támogatja.'
			)
			return
		}
		if (
			startPaymentFrontend?.email &&
			!/^[\w-]+(\.[\w-]+)*@[\w-]+(\.[\w-]+)+$/.test(startPaymentFrontend.email)
		) {
			alert('Megadott email helytelen')
			return
		}
		// TODO: Do this check on api/startPayment, add priority to passTypeId
		let redirectUrl: string = ''
		if (user && !startPaymentFrontend?.passTypeId) {
			if (
				window.location.host == 'tikex.com' ||
				window.location.host == 'tikex-staging.vercel.app' ||
				window.location.host == 'tikex-staging.com' ||
				window.location.host == 'tikex-dev.com' ||
				window.location.host == 'localhost:3000'
			) {
				redirectUrl =
					window.location.protocol + '//' + window.location.host + '/tickets'
			} else {
				const urlParams = new URLSearchParams(window.location.search)
				const dst = urlParams.get('dst')
				if (dst) {
					redirectUrl =
						window.location.protocol +
							'//' +
							window.location.hostname +
							':' +
							window.location.port +
							'/' +
							dst ?? ''
				} else {
					redirectUrl = window.location.href
				}
				localStorage.setItem('isPurchaseConfirmationVisible', 'true')
			}
		} else {
			if (
				window.location.host == 'tikex.com' ||
				window.location.host == 'tikex-staging.vercel.app' ||
				window.location.host == 'tikex-staging.com' ||
				window.location.host == 'tikex-dev.com' ||
				window.location.host == 'localhost:3000'
			) {
				redirectUrl =
					window.location.protocol +
					'//' +
					window.location.host +
					'/' +
					teamSlugUser +
					'/product/' +
					productSlugUser
			} else {
				const urlParams = new URLSearchParams(window.location.search)
				const dst = urlParams.get('dst')
				if (dst) {
					redirectUrl =
						window.location.protocol +
							'//' +
							window.location.hostname +
							':' +
							window.location.port +
							'/' +
							dst ?? ''
				} else {
					redirectUrl = window.location.href
				}
				localStorage.setItem('isPurchaseConfirmationVisible', 'true')
			}
		}
		// NOTE: for 'userSetTimeRange' can have more form to send?!
		const formId = userProductDTO?.[productSlugUser]?.formId
		let startPaymentBackend: StartPaymentBackend
		startPaymentBackend = {
			adSlug: productSlugUser,
			teamSlug: teamSlugUser,
			partnerData,
			redirectUrl,
			adSubPagesData: {
				...startPaymentFrontend!.adSubPagesData,
			},
			email: startPaymentFrontend!.email,
			formFieldData: startPaymentFrontend!.formFieldData,
			passTypeId: startPaymentFrontend!.passTypeId,
		}
		let headers: {
			[key: string]: string
		} = {
			'Content-Type': 'application/json',
		}
		if (auth?.userDTO?.token) {
			headers['Authorization'] = `Bearer ${auth?.userDTO?.token}`
		}
		const response = await fetchWithBaseUrl('startPayment', {
			method: 'POST',
			headers,
			body: JSON.stringify(startPaymentBackend),
		})
		if (response.ok) {
			const data: StartPaymentRes = await response.json()
			if (data.error) {
				alert(data.error)
			} else {
				const startPaymentRes: StartPaymentRes = data
				if (startPaymentRes.error) {
					try {
						const error = JSON.parse(startPaymentRes.error)
						if (error.Errors) {
							alert(error.Errors[0].Description)
						} else {
							alert(startPaymentRes.error)
						}
					} catch (e) {
						alert(startPaymentRes.error)
					}
				} else {
					let _startPaymentFrontend = { ...startPaymentFrontend! }

					if (
						userProductDTO?.[productSlugUser]?.timeSelectionType ==
						'userSetTimeRange'
					) {
						_startPaymentFrontend.adSubPagesData = {}
					} else {
						delete _startPaymentFrontend.adSubPagesData[productSlugUser]
					}
					delete _startPaymentFrontend.email
					if (formId) {
						delete _startPaymentFrontend.formFieldData
					}
					_startPaymentFrontend.partnerData = { country: 'Magyarország' }
					setStartPaymentFrontend(_startPaymentFrontend)
					if (platform == 'next') {
						console.log('ReactGA.event called')
						ReactGA.event({
							category: 'Payment Process',
							action: 'Barion',
						})
					}
					if (isRedirectToBarion && data.GatewayUrl) {
						console.log('window.location.href started set')
						window.location.href = data.GatewayUrl
						console.log('window.location.href finished set')
					}
				}
			}
		}
	}

	return (
		<>
			{totalPriceFormatted && isCalendar && (
				<div
					style={{
						display: 'flex',
						justifyContent: 'flex-end',
					}}
				>
					<span
						style={{
							fontWeight: 'bold',
							lineHeight: '50px',
						}}
					>
						Összeg: {totalPriceFormatted} Ft
					</span>
				</div>
			)}
			<form
				className="hc-cmp-contact-form form-box form-ajax form-ajax-wp boxed-area label-visible"
				style={{ maxWidth: '800px' }}
			>
				{platform == 'wordpress' ? (
					<></>
				) : env == 'prod' && userProductDTO?.barionPixelId ? (
					<script
						defer
						dangerouslySetInnerHTML={{
							__html: `
						// Create BP element on the window
						window["bp"] = window["bp"] || function () {
							(window["bp"].q = window["bp"].q || []).push(arguments);
						};
						window["bp"].l = 1 * new Date();
				
						// Insert a script tag on the top of the head to load bp.js
						scriptElement = document.createElement("script");
						firstScript = document.getElementsByTagName("script")[0];
						scriptElement.async = true;
						scriptElement.src = 'https://pixel.barion.com/bp.js';
						firstScript.parentNode.insertBefore(scriptElement, firstScript);
						window['barion_pixel_id'] = '${userProductDTO?.barionPixelId}';            
			
						// Send init event
						bp('init', 'addBarionPixelId', window['barion_pixel_id']);
						`,
						}}
					/>
				) : (
					<></>
				)}
				{startPaymentFrontend && productSlugUser && (
					<div className="row">
						{(!user || !user?.email) && (
							<>
								<div className="col-lg-6">
									<p>E-mail</p>
									<input
										value={startPaymentFrontend?.email ?? ''}
										onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
											setStartPaymentFrontend({
												...startPaymentFrontend,
												email: event.target.value,
											})
										}}
										className="input-text"
									/>
								</div>
								<div className="col-lg-6">
									<p>E-mail again</p>
									<input
										value={email2 ?? ''}
										onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
											setEmail2(event.target.value)
										}}
										className="input-text"
									/>
								</div>
							</>
						)}
						<div className="col-lg-6">
							{penultimateElement == 'en' ? <p>Name</p> : <p>Név</p>}
							<input
								value={startPaymentFrontend?.partnerData?.name ?? ''}
								onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
									setStartPaymentFrontend({
										...startPaymentFrontend,
										partnerData: {
											...startPaymentFrontend.partnerData,
											name: event.target.value,
										},
									})
								}}
								className="input-text"
							/>
						</div>
						<div className="col-lg-6">
							{penultimateElement == 'en' ? <p>Address</p> : <p>Cím</p>}
							<input
								value={startPaymentFrontend?.partnerData?.address ?? ''}
								onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
									setStartPaymentFrontend({
										...startPaymentFrontend,
										partnerData: {
											...startPaymentFrontend.partnerData,
											address: event.target.value,
										},
									})
								}}
								className="input-text"
							/>
						</div>
						<div className="col-lg-6">
							{penultimateElement == 'en' ? <p>City</p> : <p>Település</p>}
							<input
								value={startPaymentFrontend?.partnerData?.city ?? ''}
								onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
									setStartPaymentFrontend({
										...startPaymentFrontend,
										partnerData: {
											...startPaymentFrontend.partnerData,
											city: event.target.value,
										},
									})
								}}
								className="input-text"
							/>
						</div>
						<div className="col-lg-6">
							{penultimateElement == 'en' ? <p>Country</p> : <p>Ország</p>}
							<input
								value={startPaymentFrontend?.partnerData?.country ?? ''}
								onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
									setStartPaymentFrontend({
										...startPaymentFrontend,
										partnerData: {
											...startPaymentFrontend.partnerData,
											country: event.target.value,
										},
									})
								}}
								className="input-text"
							/>
						</div>
						<div className="col-lg-6">
							{penultimateElement == 'en' ? (
								<p>Postal code</p>
							) : (
								<p>Irányítószám</p>
							)}
							<input
								value={startPaymentFrontend?.partnerData?.postalCode ?? ''}
								onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
									setStartPaymentFrontend({
										...startPaymentFrontend,
										partnerData: {
											...startPaymentFrontend.partnerData,
											postalCode: event.target.value,
										},
									})
								}}
								className="input-text"
							/>
						</div>
						{userProductDTO?.[productSlugUser]?.isTaxCodeVisible && (
							<div className="col-lg-6">
								<p>Adószám - Csak áfaalany esetén (pl. cég)!</p>
								<input
									value={startPaymentFrontend?.partnerData?.taxCode ?? ''}
									onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
										setStartPaymentFrontend({
											...startPaymentFrontend,
											partnerData: {
												...startPaymentFrontend.partnerData,
												taxCode: event.target.value,
											},
										})
									}}
									placeholder={'pl. 12345678-1-12'}
									className="input-text"
								/>
							</div>
						)}
					</div>
				)}
				{penultimateElement == 'en' ? (
					<div
						style={{
							display: 'flex',
							flexWrap: 'wrap',
							gap: '30px',
						}}
					>
						<a
							className={
								'btn btn-sm text-bold btn-circle shadow-1 full-width-sm'
							}
							onClick={() => {
								startPayment(true)
							}}
							style={{
								display: 'inline-block',
							}}
						>
							Payment by credit card
						</a>
						<a
							className={
								'btn btn-sm text-bold btn-circle shadow-1 full-width-sm'
							}
							onClick={() => {
								completion?.()
							}}
							style={{
								display: 'inline-block',
							}}
						>
							Back
						</a>
					</div>
				) : (
					<div
						style={{
							gap: '30px',
						}}
						className="flex-responsive"
					>
						<a
							className={
								'btn btn-sm text-bold btn-circle shadow-1 full-width-sm'
							}
							onClick={() => {
								startPayment(true)
							}}
							style={{
								display: 'inline-block',
							}}
						>
							Fizetés bankkártyával
						</a>
						<a
							className={
								'btn btn-sm text-bold btn-circle shadow-1 full-width-sm'
							}
							onClick={() => {
								if (completion) {
									completion()
								} else {
									window.history.back()
								}
							}}
							style={{
								display: 'inline-block',
							}}
						>
							Vissza
						</a>
					</div>
				)}

				{totalPriceFormatted && (
					<span
						style={{
							fontWeight: 'bold',
							lineHeight: '50px',
						}}
					>
						Összeg: {totalPriceFormatted} Ft
					</span>
				)}
				<a
					hidden
					data-cy="start-payment"
					onClick={() => {
						startPayment(false)
					}}
				>
					link
				</a>
			</form>
		</>
	)
}
